// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"af1b4aae","303":"027c84cd","395":"957dd040","453":"feac8ab8","775":"40bf9c71","887":"b8e8e925","958":"cfb0f837"}[chunkId] + ".chunk.js";
};